import { Component, OnInit, Inject } from '@angular/core';
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

export interface DialogData {
  transactionID: string;
  amount: number;
  receiptUrl: string;
  isPublic: boolean
}

@Component({
  selector: 'app-squareup-response',
  templateUrl: './squareup-response.component.html',
  styleUrls: ['./squareup-response.component.css']
})
export class SquareupResponseComponent implements OnInit {
  loading: false;
  display:any;
  constructor(
    private _flashMessagesService: FlashMessagesService,
    public dialogRef: MatDialogRef<SquareupResponseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private router: Router
  ) { }

  ngOnInit() {
    this.dialogRef.afterOpen().subscribe(() => {
      if (this.data.isPublic) {
        this.timer();
        setTimeout(() => {
          this.dialogRef.close();
        }, 6000);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close(this.data);
  }

  timer() {
    let minute = .6;
    let seconds: number = 6;
    let textSec: any = "0";
    let statSec: number = 6;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

}


// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/squareup-response/squareup-response.component.ts